<template>
  <b-modal :id="`migracao`"
           :ref="`migracao`"
           :hide-footer="true"
           no-close-on-backdrop
           no-close-on-esc
           class="MigracaoDados"
           :visible="true"
           header-class="MigracaoDados_header"
           size="xl">
    <template slot="modal-header">
      <div>
        <icon-svg icon="hourIcon"
                  class="icon--sm icons--white" />
        <b class="ml-2">Recuperação de dados</b>
      </div>
    </template>
    <div v-if="ativo < 2"
         class="text-center">
      <p>Aguarde um momento, estamos recuperando os registro da CRC.</p>
    </div>
    <div v-if="ativo == 2"
         class="text-center">
      <p>Pronto!</p>
    </div>
    <div v-if="ativo < 2">
      <div class="steps-migracao">
        <div class="step">
          <div class="circle"
               :class="{'active': ativo === -1, 'completed': ativo > -1 }"
               data-text="1" />
          <div class="bar"
               :class="{'completed': ativo > -1}" />
          <h1>Buscando dados</h1>
        </div>
        <div class="step">
          <div class="circle"
               :class="{'active': ativo === 0, 'completed': ativo > 0}"
               data-text="2" />
          <div class="bar"
               :class="{'completed': ativo > 0}" />
          <h1>Processando dados</h1>
        </div>
        <div class="step">
          <div class="circle"
               :class="{'active': ativo === 1, 'completed': ativo > 1}"
               data-text="3" />
          <h1>Salvando dados</h1>
        </div>
      </div>
    </div>

    <div v-else-if="ativo === 2"
         class="text-center">
      <div class="form-group">
        <icon-svg icon="check"
                  class="check-success-migracao" />
        <p class="text-config">
          Dados recuperados com sucesso!
        </p>
      </div>
    </div>

    <div v-else-if="ativo === 3"
         class="text-center">
      <div class="form-group">
        <icon-svg icon="error"
                  class="error-migracao" />
        <p class="text-config">
          Erro ao recuperar dados. Entre em contato com o suporte!
        </p>
      </div>
    </div>
    <div class="row justify-content-end mt-4">
      <button class="btn btn-sm btn-secondary mr-2 px-3"
              @click="hideModal">
        Fechar
      </button>
    </div>
  </b-modal>
</template>
<script>
  export default {
    name: 'Migracao',
    props: {
      propStatus: {type: String, default: ''},
      propText: { type: String, default: ''}
    },
    data () {
      return {
        step: 0,
        status: {
          'IN_QUEUE': -1,
          'PENDING': -1,
          'REQUESTING': -1,
          'PROCESSING': 0,
          'PENDING_PROCESS_MONGO': 1,
          'PROCESSING_MONGO': 1,
          'COMPLETED': 2,
          'FAILED': -1
        },
        ativo: 0
      }
    },
    watch: {
      propStatus () {
        this.ativo = this.status[this.propStatus]
      }
    },
    mounted () {
      this.ativo = this.status[this.propStatus]
    },
    methods: {
      hideModal () {
        this.$emit('hideModal')
      }
    }
  }
</script>
<style lang="scss">
   @import '../scss/_utilities/_exports';

  .MigracaoDados {
    position: relative;

    &_header {
      background-color: #074F7F !important;
      color: white !important;
    }
  }

  .check-migracao {
    width: 92px;
    height: 92px;
    fill: #008b27;
    margin: 0px;
  }

  .check-success-migracao {
    width: 92px;
    height: 92px;
    fill: #008b27;
    margin: 16px 0px 0px 0px;
  }

  .error-migracao {
    width: 92px;
    height: 92px;
    fill: #8b0000;
    margin: 16px 0px 0px 0px;
  }

  .text-config {
    font-size: 16px;
  }

  .steps-migracao {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
  }

  .steps-migracao .step {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .steps-migracao .step div.circle {
    position: relative;
    width: 80px;
    height: 80px;
    background: #074F7F;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .steps-migracao .step div.circle::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background: #fff;
    transform: translate(-50%, -50%);
    z-index: 1100;
  }

   .steps-migracao .step div.circle.active::after {
    animation: cintilante 2s linear infinite;
  }

  @keyframes cintilante {
    0% {
      box-shadow: inset 0 0 0px #074F7F;
    }
    50% {
      box-shadow: inset 0 0 20px #074F7F;
    }
    100% {
      box-shadow: inset 0 0 0px #074F7F;
    }
  }


  .steps-migracao .step div.circle.completed::after {
    background: #074F7F;
  }

  .steps-migracao .step div.circle.completed::before {
    color: #fff;
  }

  .steps-migracao .step div.circle::before {
    content: attr(data-text);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1em;
    font-weight: 500;
    color: #074F7F;
    z-index: 2000;
  }

  .steps-migracao .step div.bar {
    position: relative;
    width: 200px;
    height: 20px;
    background: #074F7F;
  }

  .steps-migracao .step div.bar::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300px;
    height: 16px;
    background: #fff;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }

  .steps-migracao .step div.bar.completed::before {
    background: #074F7F;
  }

  .steps-migracao .step div.bar::after {
    content: '';
    position: absolute;
    top: 0;
    left: -30px;
    width: 250px;
    height: 100%;
    background: #074F7F;
    z-index: 999;
  }

  .steps-migracao .step h1 {
    position: absolute;
    bottom: -40px;
    left: -65px;
    font-size: 1em;
    font-weight: 500;
    width: calc(640px / 3);
    text-align: center;
    color: #074F7F;
  }
</style>
